import styled from 'styled-components/macro';
import dotIcon from '../../assets/dot.svg';

export const BlockWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const GrayBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${(props) => props.theme.colors.gray[50]};
  padding: 8px 12px;
  border-radius: 8px;
`;

export const ExecutorWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid ${(props) => props.theme.colors.gray[100]};
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const DateLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Dot = styled.img.attrs({
  src: dotIcon,
})`
  width: 16px;
  height: 16px;
`;

export const ExecutorIconWrapper = styled.div<{ isMobile: boolean }>`
  box-sizing: border-box;
  background-color: ${(props) => props.theme.colors.primary[100]};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.isMobile ? '40px' : '48px')};
  height: ${(props) => (props.isMobile ? '40px' : '48px')};
`;
